export class LocaleExceptionsModel {
  public id: number;
  public isoCode: string;
  public verbiage: string;
  public translation: string;
  public optionId: number;
  public isActive: boolean;
  public message: string;
}
